// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-react-" + {"454":"6321965f894bc8534033","530":"1248d5a01f93c578f902"}[chunkId] + ".js";
};